import {
  AccessEnrollmentProgressionRequestFlowName as AccessEnrollmentFlow,
  ProgramID,
} from "@/api/generated/models";

export const ACCESS_TRACKS = {
  [ProgramID.access_eckm]: {
    groupLabel: "CMS ACCESS Program",
    flowName: AccessEnrollmentFlow.access_eckm_enrollment,
    name: "Early Cardio-Kidney-Metabolic",
    label: "eCKM",
  },
  [ProgramID.access_ckm]: {
    groupLabel: "CMS ACCESS Program",
    flowName: AccessEnrollmentFlow.access_ckm_enrollment,
    name: "Cardio-Kidney-Metabolic",
    label: "CKM",
  },
  [ProgramID.access_behavioral_health]: {
    groupLabel: "CMS ACCESS Program",
    flowName: AccessEnrollmentFlow.access_behavioral_health_enrollment,
    name: "Behavioral Health",
    label: "Behavioral health",
  },
} satisfies Record<
  ProgramID,
  {
    flowName: AccessEnrollmentFlow;
    name: string;
    label: string;
    groupLabel: string;
  }
>;

/** CMS's full track name for an enrollment flow. */
export const accessTrackName = (flowName: string): string | undefined =>
  Object.values(ACCESS_TRACKS).find((track) => track.flowName === flowName)
    ?.name;
